"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalBody = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Modal = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Modal.css") : void 0);
const _excluded = ["children", "className", "isResizable"];
const CSS_BLOCK = 'sapcnqr-modal';
const ModalBody = exports.ModalBody = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      children,
      className,
      isResizable
    } = props,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  const classnames = _bind.default.bind(_Modal.default);
  const bodyClasses = classnames(`${CSS_BLOCK}__body`, {
    [`${CSS_BLOCK}__body--resizable`]: isResizable
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: bodyClasses,
    "data-nui-widgets": "Modal.Body",
    ref: ref
  }), children);
});
ModalBody.displayName = 'Modal.Body';
ModalBody.propTypes = {
  /** Content of the modal body. */
  children: _propTypes.default.node,
  /** Custom classes to add to the body’s `<div>` tag. */
  className: _propTypes.default.string,
  /** @ignore */
  isResizable: _propTypes.default.bool
};
var _default = exports.default = ModalBody;